import { useMemo } from "react";

import AdsSlotOpopular from "./Ads.Slot.Opopular";
import AdsSlotTocantins from "./Ads.Slot.Tocantins";
import AdsSlotDaqui from "./Ads.Slot.Daqui";

const slug = process.env.NEXT_PUBLIC_WEBAPP_CLIENT_SLUG || 'opopular'

export type AdsSlotProps = {
  type: 'article' | 'block' | 'mega' | 'side' | 'search' | 'newsletter'
  componentReference: 'top' | 'bottom'

  data: any | undefined
}

const AdsSlot: React.FC<AdsSlotProps> = ({type, componentReference = "bottom", data, ...props}) => {
  return useMemo(() => {
      switch (slug) {
      case 'tocantins':
        return <AdsSlotTocantins type={type} componentReference={componentReference} data={data} {...props} />
      case 'daqui':
        return <AdsSlotDaqui type={type} componentReference={componentReference} data={data} {...props} />
      default: // opopular
        return <AdsSlotOpopular type={type} componentReference={componentReference} data={data} {...props} />
    }
  }, [type, componentReference, data, props])
}

export default AdsSlot
